import { useMutation } from "react-query";
import useAuth from "./useAuth";

/**
 *  Custom hook to update inmate details based on the inmate's ID.
 * @hook useInmate
 * @author Priyanshu
 */

export default function useInmate(inmateId?: string) {
  const { request } = useAuth();

  //Mutation to update inmate details.
  const { mutateAsync: updateInmate, isLoading: isUpdatingInmate } =
    useMutation(`/inmates/${inmateId}`, (payload: any) =>
      request
        .put(`/inmates/${inmateId}`, payload)
        .then((response) => response?.data as any)
    );

  return {
    updateInmate,
    isUpdatingInmate,
  };
}
